import loadable from 'components/dynamic-import';

const ManageCommunicationsPage = loadable(() => import('./ManageCommunicationsPage'));

export { ManageCommunicationsPage };
